import Vue from 'vue';
import Router from 'vue-router';
import Login from './components/login.vue';
import Signup from './components/signup.vue';
import App from './components/app/app.vue';
import Welcome from './components/app/welcome/welcome.vue';
import Store from './components/app/store/store.vue';
import Builder from './components/app/builder/builder.vue';
import Director from './components/app/director/director.vue';
import Display from './components/display/display.vue';
import Interact from './components/interact/interact.vue';

Vue.use(Router);

export default new Router({
    // mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/signup',
            name: 'Signup',
            component: Signup
        },
        {
            path: '/app',
            name: 'App',
            component: App,
            children: [
                {
                    path: '',
                    name: 'Welcome',
                    component: Welcome,
                },
                {
                    path: 'store',
                    name: 'Store',
                    component: Store,
                },
                {
                    path: 'builder',
                    name: 'Builder',
                    component: Builder,
                },
                {
                    path: 'director',
                    name: 'Director',
                    component: Director
                }
            ]
        },
        {
            path: '/display',
            name: 'Display',
            component: Display
        },
        {
            path: '/display/disconnect',
            beforeEnter: function(to, from, next) {
                console.log('Disconnecting Display');
                localStorage.removeItem('room_id');
                localStorage.removeItem('room_code');
                localStorage.removeItem('kit_id');
                localStorage.removeItem('name');
            }
        },
        {
            path: '/:room_code',
            name: 'Interact',
            component: Interact,
            props: true
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router.js